import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface MetaFieldProps {
    label: string;
    value?: ReactNode;
    /** Renders the value on a tinted surface — use for free-text blocks. */
    block?: boolean;
    emptyText?: string;
}

const isEmpty = (value: ReactNode) =>
    value === null || value === undefined || (typeof value === 'string' && value.trim() === '');

const MetaField = ({ label, value, block = false, emptyText = '—' }: MetaFieldProps) => {
    const empty = isEmpty(value);

    return (
        <Box>
            <Typography
                variant='overline'
                component='div'
                sx={{ fontWeight: 700, color: 'text.secondary', lineHeight: 1.8, letterSpacing: 0.8 }}
            >
                {label}
            </Typography>
            <Typography
                variant='body2'
                component='div'
                sx={{
                    color: empty ? 'text.disabled' : 'text.primary',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    ...(block
                        ? { bgcolor: 'grey.50', border: '1px solid', borderColor: 'divider', borderRadius: 1, p: 1.25 }
                        : {}),
                }}
            >
                {empty ? emptyText : value}
            </Typography>
        </Box>
    );
};

export default MetaField;
